import { colors } from '@sweep-io/sweep-design';
import { TextField } from '@mui/material';

const EditTextarea = ({
  text,
  setText,
  placeholder,
  onSubmit,
  submitOnEnter = false
}: {
  text?: string;
  setText: (value: string) => void;
  placeholder?: string;
  onSubmit?: () => void;
  submitOnEnter?: boolean;
}) => {
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (submitOnEnter && onSubmit && event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      onSubmit();
    }
    // Allow shift+enter to create new line (default behavior when preventDefault is not called)
  };

  return (
    <TextField
      multiline
      value={text}
      onChange={(event: { target: { value: string } }) => {
        const value = event.target.value;
        setText(value);
      }}
      onKeyDown={handleKeyDown}
      InputProps={{
        sx: {
          fontSize: '14px',
          fontWeight: 400,
          color: colors.grey[700],
          backgroundColor: 'transparent',
          padding: 0, // remove outer padding
          '& textarea': {
            padding: 0, // remove padding inside the <textarea>
          },
          '&.MuiInputBase-root.MuiOutlinedInput-root': {
            border: 0,
            padding: 0,
            minHeight: 'unset',
          },
        },
      }}
      sx={{
        '& .MuiOutlinedInput-root': {
          padding: 0,
          '& fieldset': {
            border: 'none',
          },
          '&:hover fieldset': {
            border: 'none',
          },
          '&.Mui-focused fieldset': {
            border: 'none',
          },
        },
      }}
      placeholder={placeholder}
    />
  );
};

export default EditTextarea;
